import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { onMounted, computed, ref, toRefs } from 'vue';
import Dialog from 'primevue/dialog';
import SOWReportingServiceProvider from '@/components/Utilization/SOWReportingServiceProvider.vue';
import TimeRatioReportingServiceProvider from '@/components/Utilization/TimeRatioReportingServiceProvider.vue';
import { EMIT } from '@/enum';
import { useUtilizationStore } from '@/store';
import { ClinicianInterface } from '@/types';

interface TimeUsageModalPropsInterface {
  serviceProvider: ClinicianInterface;
  reportType: string;
  filterDate: Date;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceProviderTimeUsageModal',
  props: {
    serviceProvider: {},
    reportType: {},
    filterDate: {}
  },
  setup(__props: any, { emit: __emit }) {

const utilizationStore = useUtilizationStore();

const props = __props;

const emit = __emit;

const { serviceProvider, reportType, filterDate } = toRefs(props);

const modalVisible = ref(true);

onMounted(async () => {
  utilizationStore.selectedServiceProviderId = serviceProvider.value.id.toString();
  if (isSOWReport.value) await utilizationStore.updateServiceProviderSOWFilterDate(filterDate.value);
  else await utilizationStore.updateServiceProviderTimeRatioFilterDate(filterDate.value);
});

const isSOWReport = computed<boolean>(() => reportType.value === 'sow');

const headerValue = computed<string>(() => {
  const reportTypeText = reportType.value === 'sow' ? 'SOW Reporting for' : 'Time Ratio Reporting for';
  return `${reportTypeText} ${serviceProvider.value.display_name}`;
});

const cancel = (): void => {
  modalVisible.value = false;
  emit(EMIT.CANCEL);
};

return (_ctx: any,_cache: any) => {
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: modalVisible.value,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((modalVisible).value = $event)),
    header: headerValue.value,
    draggable: false,
    modal: true,
    style: { width: '80%' },
    onHide: cancel
  }, {
    default: _withCtx(() => [
      (_unref(utilizationStore).loadingServiceProviderData)
        ? (_openBlock(), _createBlock(_component_Loader, {
            key: 0,
            class: "loader loader-height"
          }))
        : (isSOWReport.value)
          ? (_openBlock(), _createBlock(SOWReportingServiceProvider, {
              key: 1,
              "sow-data": _unref(utilizationStore).serviceProviderSOWTableData
            }, null, 8, ["sow-data"]))
          : (_openBlock(), _createBlock(TimeRatioReportingServiceProvider, {
              key: 2,
              "time-ratio-data": _unref(utilizationStore).serviceProviderTimeRatioTableData
            }, null, 8, ["time-ratio-data"]))
    ]),
    _: 1
  }, 8, ["visible", "header"]))
}
}

})